


















































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { VForm } from '@/interfaces';

@Component
export default class UserDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public dialogResetPassword = false;
  public dialogEnable2FA = false;
  public dialogDisable2FA = false;
  public formValid = false;

  public showPassword = false;
  public password = '';

  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }

  public async resetPassword() {
    if (!this.formValid) {
      this.theForm.validate();
    } else {
      const response = await this.api.updateRecord(
        this.$store,
        '/users/' + this.$route.params.id,
        {
          password: this.password
        }
      );
      this.dialogResetPassword = false;
    }
  }
  public async set2FA(enable: boolean) {
    const response = await this.api.updateRecord(
      this.$store,
      '/users/' + this.$route.params.id,
      {
        otp_required_for_login: enable
      }
    );
    if (response) {
      const ref: any = this.$refs.layout;
      if (enable) {
        ref.rec.otp_status = 'WaitForSetup';
      } else {
        ref.rec.otp_status = 'Off';
      }
      // Let detail layout component know that something changed
      ref.$refs.form.$emit('input');
    }
  }
}
